export default "__VITE_ASSET__fSHLbgDd__"